module.exports = __webpack_public_path__ + "static/media/40.7777283e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shirts/40.png
// module id = 1002
// module chunks = 0